module.exports = __webpack_public_path__ + "img/Damer.938f8d3b.jpg";